import React from 'react';

export const IconWarning: React.FC = () => <i className="bi bi-exclamation-triangle" />;
